import { render, staticRenderFns } from "./uploadModel.vue?vue&type=template&id=c6724fc8&scoped=true"
import script from "./uploadModel.vue?vue&type=script&lang=js"
export * from "./uploadModel.vue?vue&type=script&lang=js"
import style0 from "./uploadModel.vue?vue&type=style&index=0&id=c6724fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6724fc8",
  null
  
)

export default component.exports